
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'nprogress/nprogress.css'// 对应的样式

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

console.log(process.env.VUE_APP_TITLE)
console.log(process.env.VUE_APP_TITLE)
app.use(store)
  .use(router)
  .use(ElementPlus, { zIndex: 3000, size: 'small' })
  .mount('#app')
